import { Paper } from "@mui/material";
import { isNullOrWhitespace } from "@common/stringOperations.ts";
import DocumentsEmptyState from "./DocumentsEmptyState.tsx";

export interface AddDocumentsEmptyStateProps {
    canAdd: boolean;
    onAddClick: () => void;
    errorText?: string;
}

function AddDocumentsEmptyState(props: AddDocumentsEmptyStateProps) {
    return (
        <Paper
            onClick={() => {
                if (props.canAdd) {
                    props.onAddClick();
                }
            }}
            sx={(theme) => ({
                color: theme.palette.primary.main,
                border: 2,
                "&:hover": {
                    cursor: props.canAdd ? "pointer" : "default",
                },
                padding: 2,
                boxShadow: "none",
                borderColor: isNullOrWhitespace(props.errorText) ? "unset" : theme.palette.error.main,
            })}
        >
            <DocumentsEmptyState errorText={props.errorText} />
        </Paper>
    );
}

export default AddDocumentsEmptyState;
